'use strict';
var unitas = unitas || {};
const siteNav = document.querySelector('#js-site-navigation');
const siteNavOpen = document.querySelector('#js-site-nav-open');
const subMenuToggles = document.querySelectorAll('.js-sub-menu-toggle-btn');
unitas.mobilenavigation = unitas.mobilenavigation || function () {
	function init() {
        if(siteNavOpen) {
            siteNavOpen.addEventListener('click', function(){
                siteNavOpen.classList.toggle('site-nav-open--open');
                siteNav.classList.toggle('site-navigation--open');
            });
        }

        if(subMenuToggles) {
            for (let i = 0; i < subMenuToggles.length; i++) {
                const current = subMenuToggles[i];
                current.addEventListener('click', function(e){
                    const clickedToggle = e.currentTarget;
                    const submenu = clickedToggle.parentNode.querySelector('.sub-menu');

                    if(submenu && !submenu.classList.contains('sub-menu--open')) {
                        const maxHeight = submenu.scrollHeight;
                        clickedToggle.classList.add('sub-menu__toggle-btn--open');
                        submenu.classList.add('sub-menu--open');
                        submenu.style.maxHeight = maxHeight + 'px';
                    } else {
                        clickedToggle.classList.remove('sub-menu__toggle-btn--open');
                        submenu.classList.remove('sub-menu--open');
                        submenu.style.maxHeight = 0 + 'px';
                    }
                });
            }
        }
	}
	return {
		init : init
	};
}();